import { PRODUCTS_ACTION_TYPES } from '../../../products/actions';

export const initialState = {};

function bestSeller(state = initialState, action = {}) {
  switch (action.type) {
    case PRODUCTS_ACTION_TYPES.START_LOADING_PRODUCT:
      if (action.payload.id !== state.id) { return state; }
      return { ...state, loading: true };
    case PRODUCTS_ACTION_TYPES.STOP_LOADING_PRODUCT:
      if (action.payload.id !== state.id) { return state; }
      return { ...state, loading: false };
    default:
      return state;
  }
}

export default bestSeller;
